import React, { CSSProperties, ReactNode } from 'react'
import { Button, Empty, Typography } from 'antd'

interface CallAction {
  text: string
  handler: () => void
}

interface EmptyStateProps {
  title?: string
  subtitle?: string
  callAction?: CallAction
  image?: ReactNode
  imageStyle?: CSSProperties
  children?: ReactNode
}

const EmptyState: React.FC<EmptyStateProps> = ({ subtitle, title, callAction, image, imageStyle, children }) => {
  return (
    <Empty
      imageStyle={imageStyle}
      image={image}
      description={
        <>
          {!!title && <Typography style={{ fontSize: '16px', fontWeight: 'bold' }}>{title}</Typography>}
          {!!subtitle && (
            <Typography style={{ color: '#00000073', fontSize: '14px', fontWeight: 400 }}>{subtitle}</Typography>
          )}
        </>
      }
    >
      {!!callAction && (
        <Button onClick={callAction.handler} type='primary' style={{ zIndex: 99999999 }}>
          {callAction.text}
        </Button>
      )}
      {!!children && <>{children}</>}
    </Empty>
  )
}

export default EmptyState
